
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media-coverage",
      function () {
        return require("private-next-pages/media-coverage/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media-coverage"])
      });
    }
  